import { render, staticRenderFns } from "./ModalRemoveDomain.vue?vue&type=template&id=4ef405e4&scoped=true&"
import script from "./ModalRemoveDomain.vue?vue&type=script&lang=js&"
export * from "./ModalRemoveDomain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef405e4",
  null
  
)

export default component.exports